import { livenessErrors } from '@interco/inter-frontend-liveness-lib'

export const LIVENESS_ERROR_SHEET_TITLE = 'Erro ao realizar a biometria'
export const LIVENESS_ERROR_FALLBACK_MESSAGE = 'Ocorreu um erro ao realizar a biometria'
export const LIVENESS_RETRYABLE_VALIDATION_TITLE = 'Não foi possível validar sua biometria'
export const LIVENESS_RETRYABLE_VALIDATION_MESSAGE =
  'Verifique a iluminação, use um fundo claro e mantenha o rosto bem enquadrado. Depois, tente novamente.'

export interface LivenessErrorSheet {
  title: string
  message: string
}

export const errorMessage: Record<string, string> = {
  [String(livenessErrors.SERASA_EXPERIAN_IDF_GET_SEED_ERROR.code)]:
    'Erro ao obter informações necessárias para a biometria',
  [String(livenessErrors.SERASA_EXPERIAN_IDF_LIVENESS_CHECK_ERROR.code)]:
    'Erro ao validar a biometria',
  [String(livenessErrors.SERASA_EXPERIAN_IDF_LIVENESS_CHECK_FAILED_AND_CANNOT_RETRY_ERROR.code)]:
    'Biometria não validada',
  [String(livenessErrors.SERASA_EXPERIAN_IDF_LIVENESS_CHECK_FAILED_AND_CAN_RETRY_ERROR.code)]:
    LIVENESS_RETRYABLE_VALIDATION_MESSAGE,
  [String(livenessErrors.SERASA_EXPERIAN_IDF_LIVENESS_SETUP_ERROR.code)]:
    'Erro ao configurar a biometria',
  [String(livenessErrors.SERASA_EXPERIAN_IDF_LIVENESS_START_ERROR.code)]:
    'Erro ao iniciar a captura da biometria',
  [String(livenessErrors.SERASA_EXPERIAN_IDF_LOAD_SCRIPT_ERROR.code)]:
    'Erro ao carregar a biometria',
  [String(livenessErrors.SERASA_EXPERIAN_IDF_SETUP_ERROR.code)]: 'Erro ao iniciar a biometria',
}

export const getLivenessErrorSheet = (code?: string | number): LivenessErrorSheet => {
  const isRetryableValidation =
    String(code) ===
    String(livenessErrors.SERASA_EXPERIAN_IDF_LIVENESS_CHECK_FAILED_AND_CAN_RETRY_ERROR.code)

  return {
    title: isRetryableValidation ? LIVENESS_RETRYABLE_VALIDATION_TITLE : LIVENESS_ERROR_SHEET_TITLE,
    message: errorMessage[String(code)] || LIVENESS_ERROR_FALLBACK_MESSAGE,
  }
}
